/** Nó `users/{uid}` do RTDB (produção + legado). */

export function getProfilePhone(userNode) {
  if (!userNode) return ''
  const nested = userNode.profile?.phone
  if (nested != null && String(nested).trim() !== '') return String(nested).trim()
  if (userNode.phone != null && String(userNode.phone).trim() !== '') return String(userNode.phone).trim()
  return ''
}

export function getProfileDisplayName(userNode, authDisplayName) {
  if (authDisplayName?.trim()) return authDisplayName.trim()
  if (!userNode) return ''
  return (
    userNode.displayName ||
    userNode.name ||
    userNode.profile?.name ||
    ''
  ).trim()
}
